// @ts-check
import SwishMatchInfoModel from "./swish-match-info-model";
import SwishMatchStatsModel from "./swish-match-stats-model";
import SwishPlayerStatsModel from "./swish-player-stats-model";

export default class SwishBetBuilderMarketsModel {
  /**
   * class constructor method
   * @param {import('./interface').ApiSwishMarkets} data
   * @param {{homeTeam:string,guestTeam:string}} matchDetails
   */
  constructor(data, matchDetails) {
    const spreadMap = {};
    const matchPreMatchMarkets = data.MatchPreMatchMarkets.reduce((acc, market) => {
      if (!acc['prematch'][market.st]) {
        acc['prematch'][market.st] = [];
      }
      const swishPrematchModel = new SwishMatchStatsModel({
        mmid: market.mmid,
        sid: market.sid,
        t: market.t,
        l: market.l,
        oo: market.oo,
        uo: market.uo,
        sm: data.MatchSwishA.sm,
        homeTeam: matchDetails.homeTeam,
        guestTeam: matchDetails.guestTeam,
        sln: market.sln || false,
        stm: market.stm || false,
      });
      const isSpreadMarket = market.sln && market.stm;
      if (isSpreadMarket) {
        const absLine = Math.abs(market.l);
        if (typeof spreadMap[absLine] !== 'undefined') {
          // If new market is home replace old one with home, and add the awaySpread prop inside
          const swModel = acc['prematch'][market.st][spreadMap[absLine]];
          let awaySpread = swishPrematchModel;
          if (market.t === 'home') {
            awaySpread = swModel;
            acc['prematch'][market.st][spreadMap[absLine]] = swishPrematchModel;
          }
          // Add the away team prop inside exisitg model
          acc['prematch'][market.st][spreadMap[absLine]].awaySpread = awaySpread;
          return acc;
        }
      }
      acc['prematch'][market.st].push(swishPrematchModel);
      if (isSpreadMarket) {
        const absLine = Math.abs(market.l);
        spreadMap[absLine] = acc['prematch'][market.st].length - 1;
      }
      return acc;
    }, { prematch: {} });
    const matchPlayerPropsMarkets = data.MatchPlayerProps.reduce((acc, category) => {
      if (!acc[category.pr]) {
        acc[category.pr] = {};
      }
      category.ps.forEach((playerStats => {
        if (!acc[category.pr][playerStats.st]) {
          acc[category.pr][playerStats.st] = [];
        }
        playerStats.s.forEach((statistic) => {
          acc[category.pr][playerStats.st].push(new SwishPlayerStatsModel({
            ...statistic,
            sid: playerStats.sid,
            sm: data.MatchSwishA.sm
          }));
        })
      }));
      return acc;
    }, {});
    /**
     * Swish markets
     * @type {{[x:string]: {[st:string]: SwishMatchStatsModel[] | SwishPlayerStatsModel[]}}}
     */
    this.markets = { ...matchPreMatchMarkets, ...matchPlayerPropsMarkets };
    /**
     * Match info
     * @type {SwishMatchInfoModel}
     */
    this.matchInfo = new SwishMatchInfoModel(data.MatchSwishA);
  }
}